import React, { Component, useState } from "react";
import "./ResetPassword.css";
import { FaCheck } from "react-icons/fa";
import Colors from "../../constants/Colors";
import ClipLoader from "react-spinners/ClipLoader";
import PropTypes, { string } from "prop-types";
import { useTranslation } from "react-i18next";
import firebase from "../../firebase/firebase";
import { IoIosClose } from "react-icons/io";

enum Status {
  LOADING,
  INPUT,
  SUCCESS,
  ERROR,
}

interface IState {
  status: Status;
  newPassword?: string;
  newPasswordRepeat?: string;
}

type Props = {
  oobCode: string;
};

type PasswordInputProps = {
  evaluateNewPassword: (newPassword: string) => void;
};

export default class ResetPassword extends Component<Props> {
  state: Readonly<IState> = {
    status: Status.LOADING,
  };

  evaluateNewPassword(newPassword: string) {
    let that = this;

    this.setState({
      loading: true,
    });

    firebase
      .auth()
      .confirmPasswordReset(this.props.oobCode, newPassword)
      .then(function (resp) {
        that.setState({
          loading: false,
          status: Status.SUCCESS,
        });
      })
      .catch(function (error) {
        console.log(error);
        that.setState({
          loading: false,
          status: Status.ERROR,
        });
      });
  }

  renderContent() {
    if (this.state.status === Status.INPUT) {
      return (
        <PasswordInputs
          evaluateNewPassword={(newPassword: string) =>
            this.evaluateNewPassword(newPassword)
          }
        />
      );
    } else if (this.state.status === Status.SUCCESS) {
      return <SuccessMessage />;
    } else {
      return <ErrorMessage />;
    }
  }

  componentDidMount() {
    let that = this;

    firebase
      .auth()
      .verifyPasswordResetCode(this.props.oobCode)
      .then(function (email) {
        that.setState({
          loading: false,
          status: Status.INPUT,
        });
      })
      .catch(function (error) {
        that.setState({
          loading: false,
          status: Status.ERROR,
        });
        console.log(error);
      });
  }

  render() {
    return (
      <div className={"mainContainer"}>
        {!(this.state.status === Status.LOADING) && this.renderContent()}
        <ClipLoader
          size={80}
          color={Colors.mainColor}
          loading={this.state.status === Status.LOADING}
        />
      </div>
    );
  }
}

function SuccessMessage() {
  const { t } = useTranslation();

  return (
    <div className={"innerContent"}>
      <div className={"iconContainer backgroundGreenColor"}>
        <FaCheck color={Colors.white} size={30} />
      </div>

      <div className={"messageContainer"}>
        <h2 style={{ fontWeight: 400 }}>{t("auth.resetPasswordSuccess")}</h2>
      </div>
    </div>
  );
}

function PasswordInputs(props: PasswordInputProps) {
  const [newPassword, setNewPassword] = useState("");
  const [newPasswordRepeat, setNewPasswordRepeat] = useState<string>();
  const [error, setError] = useState(false);
  const { t } = useTranslation();

  function handleClick() {
    if (newPassword.length >= 7) {
      if (newPassword !== newPasswordRepeat) {
        setError(true);
      } else {
        props.evaluateNewPassword(newPassword);
      }
    }
  }

  return (
    <div
      className={"innerContent passwordResetContainer"}
      style={{ flexDirection: "column" }}
    >
      <h2>{t("auth.setNewPassword")}</h2>

      {newPassword.length < 7 && !error && (
        <h4 style={{ color: "#767676" }}>
          {t("auth.neededPasswordLength")}: {7 - newPassword.length}
        </h4>
      )}

      {newPassword.length >= 7 && !error && (
        <h4 style={{ color: "#83D8C1" }}>{t("auth.hasNeededLength")}</h4>
      )}

      {error && (
        <h4 style={{ color: "#FD5150" }}>{t("auth.passwordsNotTheSame")}</h4>
      )}

      <input
        type="password"
        value={newPassword}
        placeholder={"Passwort"}
        onChange={(event) => {
          setError(false);
          setNewPassword(event.target.value);
        }}
        className={error ? "error" : ""}
      />
      <input
        type="password"
        value={newPasswordRepeat}
        placeholder={"Passwort wiederholen"}
        onChange={(event) => {
          setError(false);
          setNewPasswordRepeat(event.target.value);
        }}
        className={error ? "error" : ""}
      />

      <a
        onClick={() => handleClick()}
        title="Press Me"
        style={newPassword.length < 7 ? { opacity: 0.3 } : {}}
        className={"button"}
      >
        {t("auth.setBack")}
      </a>
    </div>
  );
}

function ErrorMessage() {
  const { t } = useTranslation();

  return (
    <div className={"innerContent"}>
      <div className={"iconContainer backgroundMainColor"}>
        <IoIosClose color={Colors.white} size={90} />
      </div>

      <div className={"messageContainer"}>
        <h2 style={{ fontWeight: 400 }}>{t("auth.linkIsNotValid")}</h2>
        <h3>
          {t("auth.resetPasswordErrorDescriptionFirst")}
          <br />
          {t("auth.resetPasswordErrorDescriptionSecond")}
        </h3>
      </div>
    </div>
  );
}
